export default /* css */`
:host {
  --asm-color-default: var(--ui-sys-color-on-surface);
  --asm-color-literal: 14, 91%, 70%;
  --asm-color-number: 14, 91%, 70%;
  --asm-color-register: 221, 100%, 76%;
  --asm-color-string_literal: 42, 100%, 67%;
  --asm-color-character_constant: 42, 100%, 67%;
  --asm-color-immediate_value: 14, 91%, 70%;
  --asm-color-left_paren: 50, 100%, 50%;
  --asm-color-right_paren: 50, 100%, 50%;
  --asm-color-left_curly_brace: 50, 100%, 50%;
  --asm-color-right_curly_brace: 50, 100%, 50%;
  --asm-color-left_brack: 50, 100%, 50%;
  --asm-color-right_brack: 50, 100%, 50%;
  --asm-color-dot: 265, 69%, 75%;
  --asm-color-colon: 265, 69%, 75%;
  --asm-color-operator: 354, 92%, 72%;
  --asm-color-quote: 129, 58%, 91%;
  --asm-color-directive: 265, 69%, 75%;
  --asm-color-opcode: 86, 100%, 75%;
  --asm-color-label: 354, 92%, 72%;

  --memory-color-address: var(--ui-sys-color-primary);
  --memory-color-ascii: var(--ui-sys-color-secondary);

  --register-color-name: var(--ui-sys-color-primary);
  --register-color-ascii: var(--ui-sys-color-secondary);

  --font-size: 14px;
  --line-height: 1.5;
  --line-color-active: var(--ui-sys-color-on-surface);
  --container-background-color: 0, 0%, 14%;
  --container-shape: 16px;
  --container-padding: 24px;

  --top-bar-padding-top: 8px;
  --top-bar-padding-bottom: 8px;

  --selection-color: var(--ui-sys-color-surface-variant);
}

::slotted(textarea){
  display: none;
}

[theme="light"] {
  --asm-color-literal: 14, 91%, 50%;
  --asm-color-number: 14, 91%, 50%;
  --asm-color-register: 221, 100%, 56%;
  --asm-color-string_literal: 42, 100%, 37%;
  --asm-color-character_constant: 42, 100%, 57%;
  --asm-color-immediate_value: 14, 91%, 50%;
  --asm-color-left_paren: 50, 100%, 50%;
  --asm-color-right_paren: 50, 100%, 50%;
  --asm-color-left_curly_brace: 50, 100%, 40%;
  --asm-color-right_curly_brace: 50, 100%, 40%;
  --asm-color-left_brack: 50, 100%, 40%;
  --asm-color-right_brack: 50, 100%, 40%;
  --asm-color-dot: 265, 69%, 55%;
  --asm-color-colon: 265, 69%, 55%;
  --asm-color-operator: 354, 92%, 52%;
  --asm-color-quote: 129, 58%, 31%;
  --asm-color-directive: 265, 69%, 45%;
  --asm-color-opcode: 86, 100%, 25%;
  --asm-color-label: 354, 92%, 50%;
}

.editor {
  ::selection {
    background-color: hsl(var(--selection-color));
  }
}

.top-bar {
  display: flex;
  background-color: hsl(0, 100%, 100%, 0.03);
  padding-top: var(--top-bar-padding-top);
  padding-bottom: var(--top-bar-padding-top);
  padding-right: var(--container-padding);
  padding-left: var(--container-padding);
}

.wrapper {
  overflow: auto;
  padding: var(--container-padding);
}

.copy {
  margin-left: auto;
}

.lang {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copied {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: hsl(var(--container-background-color));
}

pre {
  counter-reset: line;
  margin: 0;
  font-family: monospace;
}

.line {
  color: hsl(var(--asm-color-default));
  counter-increment: line;
  font-size: var(--font-size);
  line-height: var(--line-height);
  min-height: calc(var(--font-size) * var(--line-height));
  padding: 0 calc(var(--ui-sys-unit) * 16);
  cursor: text;

  &.active {
    background-color: hsl(var(--line-color-active), 0.1);
  }

  &:before {
    user-select: none;
    width: 40px;
    display: inline-block;
    content: counter(line);
    margin-right: 16px;
    color: hsl(var(--ui-sys-color-on-surface), 0.5);
  }
}

.opcode {
  color: hsl(var(--asm-color-opcode));
}
.label {
  color: hsl(var(--asm-color-label));
  font-weight: bold;
}
.literal {
  color: hsl(var(--asm-color-literal));
}
.register {
  color: hsl(var(--asm-color-register));
}
.number {
  color: hsl(var(--asm-color-number));
}
.immediate_value {
  color: hsl(var(--asm-color-number));
}
.directive {
  color: hsl(var(--asm-color-directive));
}
.string_literal {
  color: hsl(var(--asm-color-string_literal));
}
.character_constant {
  color: hsl(var(--asm-color-character_constant));
}
.immediate_value_character_constant {
  color: hsl(var(--asm-color-character_constant));
}
.left_paren {
  color: hsl(var(--asm-color-left_paren));
}
.right_paren {
  color: hsl(var(--asm-color-right_paren));
}
.left_brack {
  color: hsl(var(--asm-color-left_brack));
}
.right_brack {
  color: hsl(var(--asm-color-left_brack));
}
.left_curl_brace {
  color: hsl(var(--asm-color-left_curly_brace));
}
.right_curl_brace {
  color: hsl(var(--asm-color-left_curly_brace));
}

.dot {
  color: hsl(var(--asm-color-dot));
  font-weight: bold;
}
.colon {
  color: hsl(var(--asm-color-colon));
  font-weight: bold;
}
.operator {
  color: hsl(var(--asm-color-operator));
  font-weight: bold;
}
.quote {
  color: hsl(var(--asm-color-quote));
}
.comment {
  opacity: 0.5;
}

.side_nav {
  display: flex;
  /* padding-top: calc(var(--ui-sys-unit) * 8); */

  &[aria-expanded="true"] {
    padding-right: calc(var(--ui-sys-unit) * 4);

    .side_nav__contents {
      overflow: visible;
      min-width: calc(var(--ui-sys-unit) * 160);
    }
  }

  .side_nav__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: calc(var(--ui-sys-unit) * 64);
  }

  .side_nav__contents {
    width: 0;
    overflow: hidden;
  }

  .explorer {
    height: 100%;
    padding: 0 0 calc(var(--ui-sys-unit) * 8) 0;

    .explorer__header {
      padding: calc(var(--ui-sys-unit) * 8) 0;

      span {
        font-weight: bold;
      }
    }

    button {
      display: block;
      border: none;
      background: none;
      margin: 0;
      color: hsl(var(--ui-sys-color-on-surface));
      width: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: calc(var(--ui-sys-unit) * 8) calc(var(--ui-sys-unit) * 16);
      font-family: var(--ui-sys-font-family-alt);

      &:hover, &:focus-visible {
        background: hsl(var(--ui-sys-color-surface-variant), 0.1);
      }

      &[aria-pressed="true"] {
        background: hsl(var(--ui-sys-color-surface-variant), 0.3);
      }

      &:focus-visible {
        --focus-ring-indicator-color: var(--ui-sys-color-secondary);
        --focus-ring-indicator-thickness: var(--ui-sys-state-focus-indicator-thickness);
        --focus-ring-outline-offset: var(--ui-sys-state-focus-indicator-outer-offset);

        outline: var(--focus-ring-indicator-thickness) solid hsl(var(--focus-ring-indicator-color));
        outline-offset: var(--focus-ring-outline-offset);
        border-radius: var(--focus-ring-shape);
      }
    }
  }
}
.container {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 8px 0 0;
  overflow: hidden;
}
.content {
  flex: 1;
  display: flex;
  height: 100%;
  padding: 0 24px 0 0;
  flex-direction: column;
}
.top_bar {
  display: flex;
  align-items: center;

  div:not(:last-child) {
    margin-right: 16px;
  }

  > ui-icon-button {
    margin-left: auto;
  }
}
.cpu_status {
  display: flex;
  align-items: center;
}
.cpu_indicator {
  display: block;
  border-radius: 100%;
  width: 12px;
  height: 12px;
  background-color: red;
  margin-left: 8px;
  font-size: 0;

  &[data-is-running="true"] {
    background-color: green;
  }
}

.controls {
  padding: 0 calc(var(--ui-sys-unit) * 8);

  ui-icon-button:not(:last-child) {
    margin-right: 8px;
  }
}

.code {
  display: grid;
  grid-template-columns: 3fr 1.5fr;
  height: 100%;
  column-gap: 16px;
  overflow:hidden;
  padding-top: 8px;
}

select {
  font-size: var(--ui-sys-typescale-body-large-font-size);
  padding-top: calc(var(--ui-sys-unit) * 17);
  padding-bottom: calc(var(--ui-sys-unit) * 17);
  padding-left: calc(var(--ui-sys-unit) * 16);
  padding-right: calc(var(--ui-sys-unit) * 40);
  background-color: transparent;
  color: hsl(var(--ui-sys-color-on-surface));
  border-radius: var(--ui-sys-shape-corner-small);
  border: 1px solid hsl(var(--ui-sys-color-outline));
  cursor: pointer;
  appearance: none;

  &:focus-visible {
    --focus-ring-indicator-color: var(--ui-sys-color-secondary);
    --focus-ring-indicator-thickness: var(--ui-sys-state-focus-indicator-thickness);
    --focus-ring-outline-offset: var(--ui-sys-state-focus-indicator-outer-offset);

    outline: var(--focus-ring-indicator-thickness) solid hsl(var(--focus-ring-indicator-color));
    outline-offset: var(--focus-ring-outline-offset);
    border-radius: var(--focus-ring-shape);
  }
}

.select__wrapper {
  position: relative;
  &:after {
    display: flex;
    content: '▾';
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding-right: calc(var(--ui-sys-unit) * 16);
  }
}

pre {
  height: 100%;
  width: 100%;
  min-height: fit-content;
  margin: 0;

  &:focus-visible {
    outline: none;
  }
}

.content_wrapper {
  flex: 1;
  border: 1px solid hsl(var(--ui-sys-color-outline));
  display: flex;
  max-width:100%;
  column-gap: 16px;
  min-height: 0;
}
.input,
.registers,
.memory,
.console {
  height: 100%;
  overflow: auto;
  flex: 1;
}

.input {


  pre {
    position: relative;
    padding: calc(var(--ui-sys-unit) * 16) 0;

    &:before {
      top: 0;
      left: 0;
      height: 100%;
      padding-left: calc(var(--ui-sys-unit) * 16);
      position: absolute;
      content: '';
      width: 40px;
      display: inline-block;
      /* border-right: 1px solid hsl(var(--asm-color-default), 0.5); */
      background-color: hsl(var(--asm-color-default), 0.05);
    }
  }
}

.registers__container {
  min-height: fit-content;
}

.register__row {
  display: flex;
  column-gap: 8px;
}

.register__name {
  min-width: 50px;
  color: hsl(var(--register-color-name));
}

.register__ascii {
  min-width: 50px;
  color: hsl(var(--register-color-ascii));
}

.console,
.registers {
  font-size: calc(var(--ui-sys-unit) * 12);
  font-family: monospace;
  padding: calc(var(--ui-sys-unit) * 16);
}

.console {

}

.memory {
  font-size: calc(var(--ui-sys-unit) * 12);
  min-width: fit-content;
  font-family: monospace;
}

.memory__table {
  overflow: hidden;
  display: grid;
  grid-template-rows: auto;
  width: 100%;
  padding: calc(var(--ui-sys-unit) * 12) calc(var(--ui-sys-unit) * 24);
}

.memory__row {
  display: grid;
  grid-template-columns: 100px 1fr 1fr;
  column-gap: 16px;
}

.memory__header {
  font-weight: bold;

  td {
    padding: 8px 0;
  }
}

.memory__address {
  color: hsl(var(--memory-color-address));
}

.memory__ascii {
  color: hsl(var(--memory-color-ascii));
}

.left {
  display: flex;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
}

.right {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.section_label {
  height: 56px;
  display: flex;
  align-items: center;
  font-weight: bold;

  > :not(:last-child) {
    margin-right: calc(var(--ui-sys-unit) * 8);
  }

  ui-icon {
    --ui-icon-color: var(--ui-sys-color-on-surface);
  }

  span:last-child {
    font-family: monospace;
    margin-left: auto;
  }
}

.tabs {
  display: flex;
  z-index: 1;
}

.tab {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  margin: 0;
  color: hsl(var(--ui-sys-color-on-surface));
  padding: 16px;
  cursor: pointer;
  margin-bottom: -1px;
  border: 1px solid hsl(var(--ui-sys-color-surface));
  border-bottom: 1px solid hsl(var(--ui-sys-color-outline));
  font-weight: bold;
  font-family: var(--ui-sys-typescale-font-family-alt);

  &:not(:first-child) {
    border-left: 1px solid hsl(var(--ui-sys-color-outline));
    margin-left: -1px;
  }

  &[aria-pressed="true"] {
    border: 1px solid hsl(var(--ui-sys-color-outline));
    border-bottom: 1px solid hsl(var(--ui-sys-color-surface));
    color: hsl(var(--ui-sys-color-primary));

    ui-icon {
      --ui-icon-color: var(--ui-sys-color-primary);
    }
  }

  ui-icon {
    margin-left: calc(var(--ui-sys-unit) * 8);
    --ui-icon-color: var(--ui-sys-color-on-surface);
  }
}

.program_dropdown {
  margin-left: calc(var(--ui-sys-unit) * 16);
  display: flex;
  align-items: center;

  label {
    margin-right: calc(var(--ui-sys-unit) * 8);
  }
}`